const Header = () => {
  return <header className="p-10 bg-black">
    <h1 className="text-4xl font-mono text-center text-white">Random
      Password Generator</h1>
  </header>;
}

export default Header;